// Named exports only: the seat and its context are shared with Button and
// IconButton through direct imports, never through the public barrel.
export { Tooltip } from './tooltip';
export type { TooltipProps } from './tooltip';
